<template>
  <span>
    <button
      class="btn"
      :class="{
        'btn-primary': form.id,
        'btn-success btn-rounded px-4 rounded-pill': !form.id,
      }"
      v-b-modal="'craneModal' + _uid"
    >
      <i v-if="form.id" class="fa fa-edit"></i>
      <i v-else class="fa fa-plus"></i>
      <span v-if="!form.id"> Új emelőgép</span>
    </button>
    <b-modal
      :id="'craneModal' + _uid"
      cancel-variant="default"
      @cancel="closeCraneModal()"
      @ok="formHandler"
      ok-title="Mentés"
      cancel-title="Mégse"
      :ok-disabled="loading"
    >
      <template slot="modal-header">
        <h4 class="modal-title" v-if="crane?.id">
          {{ crane.number }} emelőgép szerkesztése
        </h4>
        <h4 class="modal-title" v-else>Újemelőgép</h4>
        <a class="btn-close" @click="closeCraneModal()"></a>
      </template>
      <form @submit.prevent="formHandler()">
        <div class="mb-2">
          <label class="form-label">Sorszám:</label>
          <input
            type="text"
            class="form-control"
            v-model="form.number"
            :class="{ 'is-invalid': errors.number }"
          />
          <div v-if="errors.number" class="invalid-feedback d-block">
            {{ errors.number[0] }}
          </div>
        </div>
        <div class="mb-2">
          <label class="form-label">Gyártási szám:</label>
          <input
            type="text"
            class="form-control"
            v-model="form.serial_number"
            :class="{ 'is-invalid': errors.serial_number }"
          />
          <div v-if="errors.serial_number" class="invalid-feedback d-block">
            {{ errors.serial_number[0] }}
          </div>
        </div>
        <div class="mb-2">
          <label class="form-label">Megnevezés:</label>
          <input
            type="text"
            class="form-control"
            v-model="form.name"
            :class="{ 'is-invalid': errors.name }"
          />
          <div v-if="errors.name" class="invalid-feedback d-block">
            {{ errors.name[0] }}
          </div>
        </div>
        <div class="mb-2">
          <label class="form-label">Típus:</label>
          <v-select
            v-if="machine_types"
            v-model="form.machine_type"
            :options="machine_types"
            :reduce="(option) => option.id"
            label="name"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                :required="!form.machine_type"
                v-bind="attributes"
                v-on="events"
                :placeholder="!form.machine_type ? 'Válassz' : ''"
              />
            </template>
          </v-select>
          <div v-if="errors.machine_type" class="invalid-feedback d-block">
            {{ errors.machine_type[0] }}
          </div>
        </div>
        <div class="mb-2">
          <label class="form-label">Terület:</label>
          <v-select
            v-if="locations"
            v-model="form.location_id"
            :options="locations"
            :reduce="(option) => option.id"
            label="name"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                :required="!form.location_id"
                v-bind="attributes"
                v-on="events"
                :placeholder="!form.location_id ? 'Válassz' : ''"
              />
            </template>
          </v-select>
          <div v-if="errors.location_id" class="invalid-feedback d-block">
            {{ errors.location_id[0] }}
          </div>
        </div>
        <div class="mb-2">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="operational"
              :true-value="1"
              :false-value="0"
              v-model="form.operational"
            />
            <label class="form-check-label" for="operational">Üzemképes</label>
          </div>
          <div v-if="errors.operational" class="invalid-feedback d-block">
            {{ errors.operational[0] }}
          </div>
        </div>
        <div class="mb-2" v-if="!form.operational">
          <label class="form-label">Megjegyzés</label>
          <textarea
            v-model="form.comment"
            class="form-control"
            cols="30"
            rows="5"
          ></textarea>
          <div v-if="errors.comment" class="invalid-feedback d-block">
            {{ errors.comment[0] }}
          </div>
        </div>
      </form>
    </b-modal>
  </span>
</template>

<script>
import Crane from "../../../apis/Crane";

export default {
  props: {
    crane: {
      type: Object,
      default: null,
    },
    locations: {
      type: Array,
    },
    machine_types: {
      type: Array,
    },
  },
  data() {
    return {
      loading: false,
      form: {},
      errors: [],
    };
  },
  created() {
    if (this.crane) {
      this.form = { ...this.crane };
    } else {
      this.form = {
        number: "",
        serial_number: "",
        name: "",
        machine_type: null,
        location_id: null,
        operational: 1,
      };
    }
  },
  methods: {
    closeCraneModal() {
      this.form.comment = null;
      this.$bvModal.hide("craneModal" + this._uid);
    },
    updateCrane(bvModalEvt) {
      this.loading = true;
      if (bvModalEvt) {
        //ok gombra van csak event
        bvModalEvt.preventDefault();
      }
      this.$refs.crane_form.formHandler();
    },
    updatedCrane(crane) {
      this.loading = false;
      this.$emit("crane-updated", crane);
      this.closeCraneModal();
    },
    addCrane(bvModalEvt) {
      this.loading = true;
      if (bvModalEvt) {
        //ok gombra van csak event
        bvModalEvt.preventDefault();
      }
      this.$refs.crane_form.formHandler();
    },
    addedCrane(crane) {
      this.loading = false;
      this.$emit("crane-added", crane);
      this.closeCraneModal();
    },
    formHandler(bvModalEvt) {
      if (bvModalEvt) {
        //ok gombra van csak event
        bvModalEvt.preventDefault();
      }
      if (this.form.id) {
        Crane.update(this.form.id, this.form)
          .then((response) => {
            console.log(response.data);
            this.closeCraneModal();
            this.$emit("crane-updated", response.data);
          })
          .catch((error) => {
            if (error.response.data.errors) {
              this.errors = error.response.data.errors;
            }
            this.$emit("failed");
          });
      } else {
        Crane.add(this.form)
          .then((response) => {
            this.closeCraneModal();
            this.$emit("crane-added", response.data);
            this.form = {
              number: "",
              serial_number: "",
              name: "",
              machine_type: null,
              location_id: null,
              operational: 1,
            };
          })
          .catch((error) => {
            if (error.response.data.errors) {
              this.errors = error.response.data.errors;
            }
            this.$emit("failed");
          });
      }
    },
  },
};
</script>
